export const achievements = [
    {
        "_id": "671bd89660b6823335a0af04",
        "id": "8fbb5f23-8c17-4dcc-9d23-3b0b21f9a417",
        "eventId": "161759",
        "name": "Watch Keynote: Harnessing the Power of Positivity",
        "value": 75,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bd8b460b6823335a0af05",
        "id": "d7866926-e835-4266-80f3-141839538004",
        "eventId": "161759",
        "name": "Watch Keynote: Robot Ethics and the Future of Human-Robot Interaction",
        "value": 75,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bd8de60b6823335a0af06",
        "id": "c9e7da51-8713-4c20-a6cb-d31c1b528a28",
        "eventId": "161759",
        "name": "Watch Keynote: Embedding a Culture of Innovation into Everyone’s DNA",
        "value": 75,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bd8eb60b6823335a0af07",
        "id": "366324a6-11cb-48dc-a30e-c070878a80d8",
        "eventId": "161759",
        "name": "Watch Keynote: How to Think Like a Hacker and Help Your Organisation Handle Incidents",
        "value": 75,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bd90060b6823335a0af08",
        "id": "9ec8a79f-d117-4ee2-a39e-0d48cb56b97c",
        "eventId": "161759",
        "name": "Watch Keynote: The State of Security: Using pressure to prosper as a security leader",
        "value": 75,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bd90d60b6823335a0af09",
        "id": "656eedfd-6289-40e1-ac46-5a800d3f37fd",
        "eventId": "161759",
        "name": "Watch Keynote: The Power of Choice",
        "value": 75,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671be3c260b6823335a0af0b",
        "id": "0188c8e5-44a4-40ea-a9fb-a1bf2550c2da",
        "eventId": "161759",
        "name": "Download content from Exploration Zone",
        "value": 20,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671be4b260b6823335a0af0c",
        "id": "2103edc2-c262-45a1-8855-dfcb8abd89b2",
        "eventId": "161759",
        "name": "Listen to ISF podcast in Exploration Zone",
        "value": 40,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671be4ca60b6823335a0af0d",
        "id": "9c48d561-8757-4a27-8cd2-663064dfe602",
        "eventId": "161759",
        "name": "Listen to ISF podcast in Exploration Zone Day 2",
        "value": 40,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671be4d860b6823335a0af0e",
        "id": "97281b89-78f6-4ef8-8bb2-e63527bf8ee0",
        "eventId": "161759",
        "name": "Listen to ISF podcast in Exploration Zone Day 3",
        "value": 40,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf61160b6823335a0af0f",
        "id": "715cc7cc-a47c-4221-9ddd-76baa28efc48",
        "eventId": "161759",
        "name": "Watch ISF video in Exploration Zone",
        "value": 40,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf62760b6823335a0af10",
        "id": "e53912ec-f01c-4610-8363-b5bffa4ee11e",
        "eventId": "161759",
        "name": "Complete survey in Exploration Zone",
        "value": 40,
        "allowsMultiple": false,
        "description": "",
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f060b6823335a0af11",
        "id": "b56ad03f-4bbf-4f24-ac68-bea87a32a7ed",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: Harnessing the Power of Positivity",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af12",
        "id": "2aec6c7b-0530-4770-a5d0-02b47dfc1bd7",
        "eventId": "161759",
        "name": "Provide Feedback - V1.1 Diffused Perspectives Virus (DPV): How to fight this highly contagious virus that ruins your awareness programme",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af13",
        "id": "66e7af3c-b1b4-443b-9b95-d340c90d3f97",
        "eventId": "161759",
        "name": "Provide Feedback - V1.1 Diffused Perspectives Virus (DPV): How to fight this highly contagious virus that ruins your awareness programme",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af14",
        "id": "4f86dde3-4cc9-4d67-849c-35831062b140",
        "eventId": "161759",
        "name": "Provide Feedback - V2.1 Danger From Within: Real-life insider threats and how to address this topic",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af15",
        "id": "089b663c-de3f-48c4-bc9f-bd186a896809",
        "eventId": "161759",
        "name": "Provide Feedback - V3.1 Manipulator to Listener: An emotional intelligence (EQ) journey",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af16",
        "id": "7ef56347-7946-4834-9196-12d03a4a7faf",
        "eventId": "161759",
        "name": "Provide Feedback - V4.1 Security Leadership Panel: Staying the course",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af17",
        "id": "26671b65-5c5d-44a8-be5d-b513ded1b02d",
        "eventId": "161759",
        "name": "Provide Feedback - V5.1 Risky Business: Building a flexible everyday risk framework",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af18",
        "id": "12765195-e5da-40ac-9129-0e8965791889",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: Robot Ethics and the Future of Human-Robot Interaction",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af19",
        "id": "b10d1e1a-8e10-4231-9636-1570c6d9e312",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: Embedding a Culture of Innovation into Everyone’s DNA",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f160b6823335a0af1a",
        "id": "17cfc0d0-1b74-4834-a021-926a317ce32f",
        "eventId": "161759",
        "name": "Provide Feedback - V6.1 Why are our Teams Burning Out? Lessons learnt to keep the fires at bay",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af1b",
        "id": "d3d2e0b4-1201-48da-8ac2-dcee0015f59a",
        "eventId": "161759",
        "name": "Provide Feedback - V7.1 A Gen Z'ers Perspective on Rejuvenating Your Security Workforce",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af1c",
        "id": "6e906192-9f82-4dd3-ac44-c4b652bd960c",
        "eventId": "161759",
        "name": "Provide Feedback - V8.1 Regulation vs. Innovation: How much is too much?",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af1d",
        "id": "a79f7b04-7c74-4854-8171-95847b9d5a36",
        "eventId": "161759",
        "name": "Provide Feedback - V9.1 Are You Compliant or are You Ready? Surviving an extinction level event",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af1e",
        "id": "3d574e58-cb18-4cf8-bbef-c7b6efa0dfab",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: How to Think Like a Hacker and Help Your Organisation Handle Incidents",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af1f",
        "id": "dda4ea1b-1f27-4c28-aeb8-4091fd17bab0",
        "eventId": "161759",
        "name": "Provide Feedback - Panel Discussion: Hacking ICS and handling OT incidents",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af20",
        "id": "aa61f4a0-7a74-4a11-b9ab-eb9c8b17c2c2",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: The State of Security: Using pressure to prosper as a security leader",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af21",
        "id": "32eadb56-1b97-4a95-a5aa-dac0e1a61a59",
        "eventId": "161759",
        "name": "Provide Feedback - V10.1 Securing the Supply Chain: A cross-collaborative approach",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af22",
        "id": "064dc76f-1f67-482a-acec-a8d8ce55af50",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: The Power of Choice",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af23",
        "id": "f7096b88-2fe7-43dc-a601-25b6afaad0d7",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: Harnessing the Power of Positivity",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f260b6823335a0af24",
        "id": "56dabef5-03a5-496e-92ae-a168cc279d87",
        "eventId": "161759",
        "name": "Provide Feedback - V1.2 Looking Beyond Zero Trust to Cybersecurity Mesh Architecture",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af25",
        "id": "39b16939-dfc1-480f-b6fa-440e8b0d581b",
        "eventId": "161759",
        "name": "Provide Feedback - V2.2 ThreatLocker: How to Create Successful Malware and Defend with Zero Trust",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af26",
        "id": "a0e1136a-7ef5-4a7b-bc4e-b3c7d0a73841",
        "eventId": "161759",
        "name": "Provide Feedback - V3.2 SureCloud: Beyond Monitoring: Integrating Continuous Control Monitoring with GRC for comprehensive Cyber Resilience",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af27",
        "id": "09bd410e-d776-4437-b275-1d7dc3f1a38e",
        "eventId": "161759",
        "name": "Provide Feedback - V4.2 ISF Assure – An Introduction",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af28",
        "id": "7d82ae17-65c0-4664-a677-e3b3528191b1",
        "eventId": "161759",
        "name": "Provide Feedback - V5.2 Dealing with Risks and Uncertainty: The psychological phenomena that influence your security risk assessments",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af29",
        "id": "5d17ebdc-99dc-4a9a-b95d-746c84922761",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: Robot Ethics and the Future of Human-Robot Interaction",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af2a",
        "id": "5da33dd2-a108-44a0-af95-29af7c1c1742",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: Embedding a Culture of Innovation into Everyone’s DNA",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af2b",
        "id": "93a49d7f-c736-411b-8d75-5906cce987ed",
        "eventId": "161759",
        "name": "Provide Feedback - V6.2 Telenor’s Journey into Establishing a Security Threat Intelligence Radar",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af2c",
        "id": "d31e4b7d-e840-48dd-919e-1a06f44952e0",
        "eventId": "161759",
        "name": "Provide Feedback - V7.2 SecurityScorecard: Cyber Resiliency in the Supply Chain: Navigating risks amid global disruptions",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af2d",
        "id": "50691667-76c1-4ef5-8587-ac8b471b3f4a",
        "eventId": "161759",
        "name": "Provide Feedback - V8.2 Outsourcing Securely: Essential steps to ensure success",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f360b6823335a0af2e",
        "id": "68052c4e-8b0c-4cda-a9ae-5fd7f4865f91",
        "eventId": "161759",
        "name": "Provide Feedback - V9.2 A Secure Supply Chain - To be or not to be",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af2f",
        "id": "ce3b71e1-dee7-48e6-9016-e5981f75e5fa",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: How to Think Like a Hacker and Help Your Organisation Handle Incidents",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af30",
        "id": "6abf8ed5-e63c-4377-b40c-c286e4f98a3a",
        "eventId": "161759",
        "name": "Provide Feedback - Panel Discussion: Hacking ICS and handling OT incidents",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af31",
        "id": "72b234e9-6b2d-4f88-add5-bcfa23ae6e47",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: The State of Security: Using pressure to prosper as a security leader",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af32",
        "id": "b501d182-fced-4dfe-8bc8-81112e2f4a90",
        "eventId": "161759",
        "name": "Provide Feedback - V10.2 Threat Intelligence: The difference between winning and losing",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af33",
        "id": "2b09dbc5-d714-4903-b42f-317b08889001",
        "eventId": "161759",
        "name": "Provide Feedback - Keynote: The Power of Choice",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af34",
        "id": "1ec5851c-92cf-4cf6-ba27-c7c7d19622bf",
        "eventId": "161759",
        "name": "Download BlackDuck video from their stand",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af35",
        "id": "1862f32a-47ab-4342-858e-87a7a7dde84b",
        "eventId": "161759",
        "name": "Download Surecloud video from their stand",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af36",
        "id": "a47f4d56-fdc0-4684-a464-09d5e87189c6",
        "eventId": "161759",
        "name": "Download ThreatLocker video from their stand",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af37",
        "id": "22eebfdf-b8be-4de8-90d5-8536814a4db8",
        "eventId": "161759",
        "name": "Download Security Scorecard video from their stand",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af38",
        "id": "fb0bcd4b-e230-46c5-b761-6cb3e10ddb78",
        "eventId": "161759",
        "name": "Download DataBee video from their stand",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f460b6823335a0af39",
        "id": "9fdb9c88-bf48-44f9-917e-2dbbb606dcd1",
        "eventId": "161759",
        "name": "Download illumio video from their stand",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af3a",
        "id": "6d612c10-1eab-47eb-9835-2c4507a3f45a",
        "eventId": "161759",
        "name": "Download BlackDuck brochure from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af3b",
        "id": "a0a64b9f-ad3c-45a8-a8d8-101a4bece229",
        "eventId": "161759",
        "name": "Download Surecloud brochure from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af3c",
        "id": "f7989caa-6970-4686-850e-d362c669ba50",
        "eventId": "161759",
        "name": "Download ThreatLocker brochure from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af3d",
        "id": "f4a354d1-ec46-43e5-aa24-403cd790592a",
        "eventId": "161759",
        "name": "Download Security Scorecard brochure from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af3e",
        "id": "add74e9f-3370-48f1-a1ea-c3ce46de1191",
        "eventId": "161759",
        "name": "Download DataBee brochure from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af3f",
        "id": "151306f5-753e-4b48-9d7a-6a3a6b8afa19",
        "eventId": "161759",
        "name": "Download illumio brochure from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af40",
        "id": "16275f54-4e0e-4061-98a9-a234c1c80424",
        "eventId": "161759",
        "name": "Contact BlackDuck from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af41",
        "id": "b5bbf050-2d06-47ae-b5f7-d1d4ac66369b",
        "eventId": "161759",
        "name": "Contact Surecloud from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af42",
        "id": "ea11b4d8-6c9b-40fd-959b-b0754e751ee2",
        "eventId": "161759",
        "name": "Contact ThreatLocker from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f560b6823335a0af43",
        "id": "993f9e0b-db8f-4fe5-b7a3-358e345c3c1b",
        "eventId": "161759",
        "name": "Contact Security Scorecard from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f660b6823335a0af44",
        "id": "8821e145-b404-439a-882b-8b298740100b",
        "eventId": "161759",
        "name": "Contact DataBee from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "671bf9f660b6823335a0af45",
        "id": "fa806daa-f4ce-4524-a55c-32918d7bc3dd",
        "eventId": "161759",
        "name": "Contact illumio from their stand",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a85c00ecbd302c4567",
        "id": "dc6d88c5-8bab-454e-b762-4474eedb5afe",
        "eventId": "161759",
        "name": "Watch Breakout Session - V1.1 Diffused Perspectives Virus (DPV): How to fight this highly contagious virus that ruins your awareness programme",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c4568",
        "id": "6577a5c1-9e75-4ca4-9163-6e2387682041",
        "eventId": "161759",
        "name": "Watch Breakout Session - V2.1 Danger From Within: Real-life insider threats and how to address this topic",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c4569",
        "id": "158ff6b3-d565-4478-8b37-486bed4229de",
        "eventId": "161759",
        "name": "Watch Breakout Session - V3.1 Manipulator to Listener: An emotional intelligence (EQ) journey",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c456a",
        "id": "1d367764-eff6-4f57-beab-03bd3da71bf6",
        "eventId": "161759",
        "name": "Watch Breakout Session - V4.1 Security Leadership Panel: Staying the course",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c456b",
        "id": "77701438-8409-405a-a8ee-cdb7e11865f6",
        "eventId": "161759",
        "name": "Watch Breakout Session - V5.1 Risky Business: Building a flexible everyday risk framework",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c456c",
        "id": "8ccc34d2-a629-411b-a56d-b625a2fcace3",
        "eventId": "161759",
        "name": "Watch Breakout Session - V6.1 Why are our Teams Burning Out? Lessons learnt to keep the fires at bay",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c456d",
        "id": "daef577b-2894-469e-b117-490830fde3c2",
        "eventId": "161759",
        "name": "Watch Breakout Session - V7.1 A Gen Z'ers Perspective on Rejuvenating Your Security Workforce",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c456e",
        "id": "71c1ae8a-4bb1-439e-b331-175ba3f9b023",
        "eventId": "161759",
        "name": "Watch Breakout Session - V8.1 Regulation vs. Innovation: How much is too much?",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c456f",
        "id": "61eca2c0-c2ed-453d-9ae2-fb0bbf66b4d5",
        "eventId": "161759",
        "name": "Watch Breakout Session - V9.1 Are You Compliant or are You Ready? Surviving an extinction level event",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110a95c00ecbd302c4570",
        "id": "09df4484-475e-42a3-b121-7638c33038d3",
        "eventId": "161759",
        "name": "Watch Breakout Session - Panel Discussion: Hacking ICS and handling OT incidents",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4571",
        "id": "7859e58d-ba0e-42f2-8785-f4fc62aeff8b",
        "eventId": "161759",
        "name": "Watch Breakout Session - V10.1 Securing the Supply Chain: A cross-collaborative approach",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4572",
        "id": "085924d5-fb23-48c1-9276-bf497efe473f",
        "eventId": "161759",
        "name": "Watch Breakout Session - V1.2 Looking Beyond Zero Trust to Cybersecurity Mesh Architecture",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4573",
        "id": "f8e76af7-6fbd-4b9b-ae47-8f6129272e4d",
        "eventId": "161759",
        "name": "Watch Breakout Session - V2.2 ThreatLocker: How to Create Successful Malware and Defend with Zero Trust",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4574",
        "id": "66953545-1772-4d62-8f5e-e9590bc1f70f",
        "eventId": "161759",
        "name": "Watch Breakout Session - V3.2 SureCloud: Beyond Monitoring: Integrating Continuous Control Monitoring with GRC for comprehensive Cyber Resilience",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4575",
        "id": "cd1baf25-e852-4d19-8182-c5620e53dca7",
        "eventId": "161759",
        "name": "Watch Breakout Session - V4.2 ISF Assure – An Introduction",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4576",
        "id": "44e88b59-2734-43ab-a96a-11d5b01f701b",
        "eventId": "161759",
        "name": "Watch Breakout Session - V5.2 Dealing with Risks and Uncertainty: The psychological phenomena that influence your security risk assessments",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4577",
        "id": "fac36a01-4f21-4d0b-b75e-eda71aedd321",
        "eventId": "161759",
        "name": "Watch Breakout Session - V6.2 Telenor’s Journey into Establishing a Security Threat Intelligence Radar",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4578",
        "id": "c7c74514-0f46-49d9-9c79-09e77223cd64",
        "eventId": "161759",
        "name": "Watch Breakout Session - V7.2 SecurityScorecard: Cyber Resiliency in the Supply Chain: Navigating risks amid global disruptions",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c4579",
        "id": "43ee78f1-059f-48c1-9778-6cdc9be60ac1",
        "eventId": "161759",
        "name": "Watch Breakout Session - V8.2 Outsourcing Securely: Essential steps to ensure success",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110aa5c00ecbd302c457a",
        "id": "532b7d86-6d6d-4558-81c4-483ba77cfe0b",
        "eventId": "161759",
        "name": "Watch Breakout Session - V9.2 A Secure Supply Chain - To be or not to be",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672110ab5c00ecbd302c457b",
        "id": "aaa943eb-7e9f-415c-aa1c-63615cc011ab",
        "eventId": "161759",
        "name": "Watch Breakout Session - V10.2 Threat Intelligence: The difference between winning and losing",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127be5c00ecbd302c457c",
        "id": "6fca87ab-d73a-4bbd-9aa3-0b5961568f53",
        "eventId": "161759",
        "name": "Listen to Podcast Day 1",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c457d",
        "id": "09905f9d-5e72-492b-80b1-ad9ff923f6ee",
        "eventId": "161759",
        "name": "Listen to Podcast Day 2",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c457e",
        "id": "6f6cf07a-8d62-42b1-85e8-8601b948a047",
        "eventId": "161759",
        "name": "Listen to Podcast Day 3",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c457f",
        "id": "f80abaee-f0b9-4b2e-afa2-21ae308c8e9a",
        "eventId": "161759",
        "name": "Unlocking the business value of security",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c4580",
        "id": "9b75d4bf-5362-4ca2-b10a-05275bcf407c",
        "eventId": "161759",
        "name": "Exploring the role of the BISO",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c4581",
        "id": "1004dfb8-8201-422e-8855-1a1390e7506d",
        "eventId": "161759",
        "name": "Building a model of the security leader",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c4582",
        "id": "b75402e5-adfb-457a-bab8-b08972ac2a20",
        "eventId": "161759",
        "name": "Looking to the future",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c4583",
        "id": "c8e47cc5-bce3-48c9-bf1a-f06878639597",
        "eventId": "161759",
        "name": "Contact the author",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c4584",
        "id": "c705c50b-1b71-48d8-9fd8-779704506533",
        "eventId": "161759",
        "name": "Join the Leadership and Strategy community",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c4585",
        "id": "1f2a939b-7fbb-4a89-88af-2e3016674171",
        "eventId": "161759",
        "name": "Access the ISF Assure platform",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127bf5c00ecbd302c4586",
        "id": "db302d60-d8fe-4051-b4b2-8812efbda0c1",
        "eventId": "161759",
        "name": "Cyber Simulation Exercises",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c4587",
        "id": "c8f7e007-d5a9-400f-a826-d92000f1e997",
        "eventId": "161759",
        "name": "Incident Response Toolkit",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c4588",
        "id": "b36e27bc-693e-47b8-a62b-1e5ea526f867",
        "eventId": "161759",
        "name": "Get in touch with our experts",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c4589",
        "id": "edb8e2a7-a32d-4063-a4da-92824b1eeec3",
        "eventId": "161759",
        "name": "Defining and Understanding AI in Cyber",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c458a",
        "id": "2a4529da-4164-473f-beae-0e181966314f",
        "eventId": "161759",
        "name": "Offensive AI: Enhancing existing threats",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c458b",
        "id": "82470ac8-fa40-4f02-91d6-d7862c9ae730",
        "eventId": "161759",
        "name": "Defensive AI: The rewards and risks of immature new technology",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c458c",
        "id": "51c6aed0-d4e1-44ab-beb6-9343157981b6",
        "eventId": "161759",
        "name": "Join the AI community",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c458d",
        "id": "42d4341c-76ff-4b00-b240-c625dd8c973c",
        "eventId": "161759",
        "name": "How can the ISF help with  Supplier Risk Management?",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c458e",
        "id": "420ac815-8059-4d2f-b3f7-f53d9b2eed59",
        "eventId": "161759",
        "name": "Supplier Security animation",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c458f",
        "id": "1a050e8e-7ef0-4107-948b-8a9cc5834ab4",
        "eventId": "161759",
        "name": "Threat Horizon 2026: The era of entangled risks",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c05c00ecbd302c4590",
        "id": "cc7ccf53-16ef-4ffb-9552-7f6cfd20d726",
        "eventId": "161759",
        "name": "Threat Horizon 2027: PESTLE Analysis",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4591",
        "id": "7d3714e9-86c1-4f4d-9019-f288f4b30fd1",
        "eventId": "161759",
        "name": "Assessing threat predictions from TH 2023, 2024 and 2025",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4592",
        "id": "969af299-c341-47bf-a1a3-1e37c8f0a68f",
        "eventId": "161759",
        "name": "How can the ISF help you achieve compliance with DORA?",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4593",
        "id": "2ed82af9-884e-402b-9d9e-407c73a5c428",
        "eventId": "161759",
        "name": "How can the ISF help you achieve compliance with NIS2?",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4594",
        "id": "33060721-5cfe-4f67-82fe-383880ebf690",
        "eventId": "161759",
        "name": "How can the ISF help you achieve compliance with CRA?",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4595",
        "id": "0195b785-6dfb-4f34-a267-b7fca8e7140a",
        "eventId": "161759",
        "name": "The Power of Inclusive Leadership - Helle Thorning-Schmidt",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4596",
        "id": "d1d726fd-6978-4b8c-9253-dbb17fb9f9a4",
        "eventId": "161759",
        "name": "Subscribe to our podcasts",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4597",
        "id": "dace31f0-5c81-4b62-a441-ca6c2cd3c603",
        "eventId": "161759",
        "name": "Cyber Warfare and Democracy in the Age of Artificial Intelligence",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4598",
        "id": "1c4c4171-e6bb-4354-8b15-d624dc43ad8b",
        "eventId": "161759",
        "name": "The Never Normal - Peter Hinssen",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c15c00ecbd302c4599",
        "id": "96849e73-c45e-48be-a24b-6e8fc0d84fdf",
        "eventId": "161759",
        "name": "What's coming up in the ISF?",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c459a",
        "id": "8c8004bf-fe2f-4397-b06c-e28b923c2fa2",
        "eventId": "161759",
        "name": "Join your local chapter",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c459b",
        "id": "9c95f893-3910-4683-a0bf-f748a4511b97",
        "eventId": "161759",
        "name": "Get started on ISF Live",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c459c",
        "id": "f34b1839-80e2-4307-b34f-05f93a3c2f06",
        "eventId": "161759",
        "name": "Making the most of your Membership",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c459d",
        "id": "c565f127-660b-4b2f-93e3-bd74c8652693",
        "eventId": "161759",
        "name": "Get in touch with your account manager",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c459e",
        "id": "5876b93d-a632-4cce-a789-f1a5d3dee890",
        "eventId": "161759",
        "name": "Chapter Highlights",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c459f",
        "id": "3d4e1834-91b3-4274-83f1-d5c3895cf75d",
        "eventId": "161759",
        "name": "Leadership Insights series",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c45a0",
        "id": "e1b3c66d-d749-4349-8a9b-603e61230485",
        "eventId": "161759",
        "name": "AI Insights series",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c45a1",
        "id": "03ee24b8-7fb0-473c-8ee7-009c1bfe59ff",
        "eventId": "161759",
        "name": "Threat Horizon",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c45a2",
        "id": "f3bed030-0606-457a-906d-4122001d7840",
        "eventId": "161759",
        "name": "ISF Library",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c25c00ecbd302c45a3",
        "id": "533b0907-1557-4759-9dfd-fa156563755a",
        "eventId": "161759",
        "name": "Upcoming research",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45a4",
        "id": "053a5952-cf7b-40d5-aac1-65a8f4074b8d",
        "eventId": "161759",
        "name": "Meet the Experts",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45a5",
        "id": "80cc5b79-935b-4e03-936c-b81fccee521c",
        "eventId": "161759",
        "name": "Join our communities on ISF Live",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45a6",
        "id": "892ce6ee-33ef-4a4d-93b9-35b9fa0b6498",
        "eventId": "161759",
        "name": "Cyber Simulation Exercise",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45a7",
        "id": "9251b89e-a406-4a61-803b-4bab07d0169f",
        "eventId": "161759",
        "name": "Supplier Risk Management",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45a8",
        "id": "c75f3f18-864e-49db-9aac-f5721d00d641",
        "eventId": "161759",
        "name": "Find out more about ISF Services",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45a9",
        "id": "b7a4b24e-0e7f-4013-8300-8eef550fa43e",
        "eventId": "161759",
        "name": "Cyber Regulation",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45aa",
        "id": "1827a144-208c-4147-baec-e0eca991d419",
        "eventId": "161759",
        "name": "Listen and subscribe to our podcasts",
        "value": 20,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45ab",
        "id": "25b47f0c-3432-4392-b9df-3dbc841030c0",
        "eventId": "161759",
        "name": "Watch Cyber Resilience Video",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45ac",
        "id": "8dffa426-f0bb-4fed-83c1-3982059653b1",
        "eventId": "161759",
        "name": "Watch ISF Assure Video",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c35c00ecbd302c45ad",
        "id": "f1ac8f01-20df-4182-893b-1d370c76ec0e",
        "eventId": "161759",
        "name": "Watch Leadership Insights Video",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c45c00ecbd302c45ae",
        "id": "a9c38cbc-f374-4621-83b2-8de48580bf52",
        "eventId": "161759",
        "name": "Watch AI Insights Video",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c45c00ecbd302c45af",
        "id": "d864e537-2d13-4952-aaff-daa15293ff56",
        "eventId": "161759",
        "name": "Watch SUpplier Risk Management Video",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c45c00ecbd302c45b0",
        "id": "3079a4fa-a6b4-4c84-a529-6e18aa4405cc",
        "eventId": "161759",
        "name": "Watch Threat Horizon Video",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    },
    {
        "_id": "672127c45c00ecbd302c45b1",
        "id": "631836f4-6073-4ce6-aa09-d8bb96b31e36",
        "eventId": "161759",
        "name": "Watch Cyber Regulation Video",
        "value": 40,
        "allowsMultiple": false,
        "description": null,
        "limit": null,
        "timeout": null,
        "isActive": true,
        "isHidden": false,
        "startDate": null,
        "endDate": null,
        "alias": null,
        "chainOrder": null
    }
]